import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../core/services/authentication.service';

@Component({
    selector: 'app-style-guide',
    templateUrl: './style-guide.component.html',
    styleUrls: ['./style-guide.component.scss'],
    standalone: false
})
export class StyleGuideComponent implements OnInit {

    constructor(public auth: AuthenticationService,) { }

    public ngOnInit() {
    }
}
